import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, Route } from 'lucide-react';
import Layout from '../components/Layout';
import useSEO from '../hooks/useSEO';
import { useApp } from '../context/AppContext';

const T = {
  de: { title: 'Seite nicht gefunden', sub: 'Diese Seite existiert nicht (mehr). Vielleicht hilft Ihnen eine dieser Seiten weiter:', home: 'Startseite', transfers: 'Alle Transfers', book: 'Transfer buchen' },
  en: { title: 'Page not found', sub: 'This page does not exist (anymore). One of these pages may help:', home: 'Home', transfers: 'All transfers', book: 'Book a transfer' },
  fr: { title: 'Page introuvable', sub: 'Cette page n’existe pas (plus). L’une de ces pages peut vous aider :', home: 'Accueil', transfers: 'Tous les transferts', book: 'Réserver un transfert' },
  it: { title: 'Pagina non trovata', sub: 'Questa pagina non esiste (più). Una di queste pagine può aiutarti:', home: 'Home', transfers: 'Tutti i transfer', book: 'Prenota un transfer' },
};

// Soft-404 page: noindex so Google drops unknown URLs instead of treating them as duplicates of "/".
const NotFound = () => {
  const { lang } = useApp();
  const t = T[lang] || T.en;
  useSEO(`404 – ${t.title} | CAB.TAXI`, t.sub, { noindex: true });
  return (
    <Layout hideBooking>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-24 text-center" data-testid="not-found-page">
        <div className="text-7xl font-extrabold text-[color:var(--brand-dark)]">404</div>
        <h1 className="mt-3 text-2xl sm:text-3xl font-extrabold text-[color:var(--brand-dark)]">{t.title}</h1>
        <p className="mt-3 text-gray-500">{t.sub}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="accent-btn rounded-xl px-5 py-3 font-bold inline-flex items-center gap-2" data-testid="nf-home"><Home className="w-4 h-4" /> {t.home}</Link>
          <Link to="/transfers" className="rounded-xl px-5 py-3 font-bold border-2 border-[color:var(--brand-dark)] text-[color:var(--brand-dark)] inline-flex items-center gap-2" data-testid="nf-transfers"><Route className="w-4 h-4" /> {t.transfers}</Link>
          <Link to="/booking" className="rounded-xl px-5 py-3 font-bold border-2 border-gray-200 text-[color:var(--brand-dark)] inline-flex items-center gap-2" data-testid="nf-book"><Search className="w-4 h-4" /> {t.book}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
